import Text from "components/base/Text";

const Description = ({ children, ...props }) => (
  <Text type="p_lg" color="black.900" {...props}>
    {children}
  </Text>
);

export default Description;
